import { cn } from '@/src/helpers';
import { PageBody, PageHeader, PageTitle } from './atoms';
import { pageClasses } from './page.constants';

type PageProps = React.HTMLAttributes<HTMLDivElement>;

type PageComponent = React.FC<PageProps> & {
  Body: typeof PageBody;
  Header: typeof PageHeader;
  Title: typeof PageTitle;
};

export const Page: PageComponent = ({ children, className, ...rest }) => (
  <main
    {...rest}
    className={cn(pageClasses.root, className, 'm-2 flex flex-1 flex-col overflow-hidden')}
  >
    {children}
  </main>
);

Page.Body = PageBody;
Page.Header = PageHeader;
Page.Title = PageTitle;
